import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SvgColor from 'src/components/svg-color';

const icon = (name: string) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const navConfig = [
  {
    title: 'Sports',
    path: '/dashboard/sports',
    icon: <SettingsOutlinedIcon />,
  },
  {
    title: 'Games',
    path: '/dashboard/games',
    icon: icon('lock-outline'),
  },
  {
    title: 'Categories',
    path: '/dashboard/categories',
    icon: icon('shield-outline'),
  },
  {
    title: 'Puzzle Items',
    path: '/dashboard/puzzle-items',
    icon: icon('people-outline'),
  },
  {
    title: 'Image Library',
    path: '/dashboard/image-library',
    icon: icon('image-outline'),
  },
];

export default navConfig;
